<template>
  <div class="datepicker">
    <span>{{ title }}:</span>
    <div>
      <VueDatePicker
        class="datepicker-component"
        v-model="date"
        @update:model-value="handleDateChange"
        :format="formatDate"
        :time-config="{ enableTimePicker: false }"
        placeholder="Selecteer een datum"
        auto-apply
        :formats="{ input: 'dd-MM-yyyy' }"
        :filters="{ weekDays: [0, 1] }"
        :min-date="disabledDate()"
        :input-attrs="{ clearable: false }"
      />
    </div>
  </div>
</template>

<script>
import { VueDatePicker } from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { format } from 'date-fns'

export default {
  name: 'DatePicker',
  components: {
    VueDatePicker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    selectedDate: {
      required: false
    }
  },
  data() {
    return {
      date: this.getInitialDate()
    }
  },
  computed: {},
  mounted() {
    // If no date is selected or it's empty/invalid, emit the default date
    if (
      !this.selectedDate ||
      this.selectedDate === 'NONE' ||
      this.selectedDate === ''
    ) {
      this.handleDateChange(this.date)
    }
  },
  methods: {
    getInitialDate() {
      // Check if selectedDate is valid
      if (
        this.selectedDate &&
        this.selectedDate !== 'NONE' &&
        this.selectedDate !== '' &&
        this.selectedDate instanceof Date &&
        !isNaN(this.selectedDate.getTime())
      ) {
        return this.selectedDate
      }
      return this.defaultDate()
    },
    defaultDate() {
      const today = new Date()
      let daysToAdd = 4
      let resultDate = new Date(today)

      while (daysToAdd > 0) {
        resultDate.setDate(resultDate.getDate() + 1)
        const dayOfWeek = resultDate.getDay()

        if (dayOfWeek !== 0 && dayOfWeek !== 1) {
          daysToAdd--
        }
      }

      return resultDate
    },
    disabledDate() {
      const date = new Date()
      date.setDate(date.getDate() + 3)
      return date
    },
    formatDate(date) {
      /*    if (!date) return ''
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}-${month}-${year}` */
    },
    handleDateChange(val) {
      // Validate the date value
      if (!val) return

      const dateObj = val instanceof Date ? val : new Date(val)

      // Check if date is valid
      if (isNaN(dateObj.getTime())) {
        console.error('Invalid date value:', val)
        return
      }

      // Format date to dd-MM-yyyy for display, keep original for value
      const formattedDate = format(dateObj, 'dd-MM-yyyy')

      const dateOption = {
        name: val,
        title: this.title + ': ' + formattedDate,
        priceKey: 'datePicker'
      }

      this.$emit('date-selected', dateOption)

      // Format date to DD-MM-YYYY
      /*       const formattedDate = val
        ? new Date(val).toLocaleDateString('nl-NL', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })
        : ''

      const dateOption = {
        group: this.menuGroup.group || '',
        subTitle: this.menuGroup.subTitle || '',
        title: this.menuGroup.title || '',
        optionGroupName: this.optionGroupName || '',
        optionName: formattedDate,
        optionTitle: formattedDate,
        priceType: 'datePicker'
      } */
      // Add fileTypeRequired if the menu has it
      /*   if (this.menuGroup.fileTypeRequired) {
        dateOption.fileTypeRequired = this.menuGroup.fileTypeRequired
      }
 */
      //    this.$emit('date-selected', dateOption, this.selectedFileNames)
    }
  }
}
</script>

<style lang="scss" scoped>
.datepicker {
  width: 100%;
  padding: 15px 20px 15px;
  display: flex;
  align-items: center;
  font-weight: 500;
}

span {
  padding-right: 10px;
}

.dp__theme_light {
  --dp-font-family: 'Open Sans';
  --dp-border-radius: 21px;
  --dp-text-color: #4f4f4f;
  --dp-background-color: #ececec;
  --dp-input-padding: 21px;
  --dp-font-size: 14px;
  --dp-border-color: #ececec;
}
</style>
